import * as React from 'react';
import { Input } from 'antd';
import I18N from 'src/services/I18NService';

/**
 * 计费方式数据结构
 *
 * @export
 * @interface IFreightBillMethodData
 */
export interface IFreightBillMethodData {
  /** 计费方式-金额 */
  fee?: number;
  /** 计费方式-重量 */
  weight?: number;
}

interface IFreightBillMethodProps {
  /** 传入的数据 */
  value?: IFreightBillMethodData;
  /** 回调 */
  onChange?: (value: IFreightBillMethodData) => void;
}

interface IFreightBillMethodState {
  /** 计费方式-金额 */
  feeStr: string | undefined;
  /** 计费方式-重量 */
  weightStr: string | undefined;
}

class FreightBillMethod extends React.Component<IFreightBillMethodProps, IFreightBillMethodState> {
  constructor(props: IFreightBillMethodProps) {
    super(props);

    let feeStr = '';
    let weightStr = '';
    if (!!props.value) {
      if (props.value.fee !== undefined) {
        feeStr = props.value.fee.toString();
      }
      if (props.value.weight !== undefined) {
        weightStr = props.value.weight.toString();
      }
    }

    this.state = {
      feeStr,
      weightStr,
    };
  }

  /**
   * 值改变时触发
   *
   * @memberof DecoctionFeeSetting
   */
  feeChange = (e: any) => {
    try {
      let feeStr = e.target.value as string;
      feeStr = feeStr.replace(/。/g, '.');
      feeStr = feeStr.replace(/[^0-9.]/gi, '');

      const numArr = feeStr.split('.');
      if (numArr.length > 2) {
        return;
      }

      if (numArr.length > 1) {
        if (feeStr.endsWith('.')) {
          feeStr = `${feeStr}0`;
          if (isNaN(parseFloat(feeStr))) {
            return;
          }
          this.setState({
            feeStr: e.target.value,
          });
          return;
        } else {
          feeStr = `${numArr[0]}.${numArr[1].substr(0, 2)}`;
        }
      }

      if (numArr[0].trim() !== '' && isNaN(parseFloat(feeStr))) {
        return;
      }
      this.setState({
        feeStr,
      });
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * 失去焦点时触发
   *
   * @memberof DecoctionFeeSetting
   */
  feeBlur = () => {
    const fee = this.state.feeStr !== undefined && this.state.feeStr !== '' ? Number(this.state.feeStr) : undefined;
    this.triggerChange({ fee });
  };

  /**
   * 值改变时触发
   *
   * @memberof DecoctionFeeSetting
   */
  weightChange = (e: any) => {
    try {
      let weightStr = e.target.value as string;
      weightStr = weightStr.replace(/。/g, '.');
      weightStr = weightStr.replace(/[^0-9.]/gi, '');

      const numArr = weightStr.split('.');
      if (numArr.length > 2) {
        return;
      }

      if (numArr.length > 1) {
        if (weightStr.endsWith('.')) {
          weightStr = `${weightStr}0`;
          if (isNaN(parseFloat(weightStr))) {
            return;
          }
          this.setState({
            weightStr: e.target.value,
          });
          return;
        } else {
          weightStr = `${numArr[0]}.${numArr[1].substr(0, 1)}`;
        }
      }

      if (numArr[0].trim() !== '' && isNaN(parseFloat(weightStr))) {
        return;
      }
      this.setState({
        weightStr,
      });
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * 失去焦点时触发
   *
   * @memberof DecoctionFeeSetting
   */
  weightBlur = () => {
    const weight = this.state.weightStr !== undefined && this.state.weightStr !== '' ? Number(this.state.weightStr) : undefined;
    this.triggerChange({ weight });
  };

  /**
   * 回调
   *
   * @memberof FreightBillMethod
   */
  triggerChange = (changedValue: IFreightBillMethodData) => {
    const { onChange, value } = this.props;
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };

  render() {
    return (
      <span>
        <Input
          min={0.1}
          value={this.state.weightStr}
          onChange={this.weightChange}
          onBlur={this.weightBlur}
          placeholder={`${I18N.get('common_input')}`}
          style={{ width: '45%' }}
        />
        <span style={{ width: '5%', textAlign: 'center', lineHeight: '32px', display: 'inline-block' }}>kg</span>
        <Input
          min={0.01}
          value={this.state.feeStr}
          onChange={this.feeChange}
          onBlur={this.feeBlur}
          placeholder={`${I18N.get('common_input')}`}
          style={{ width: '45%' }}
        />
        <span style={{ width: '5%', textAlign: 'center', lineHeight: '32px', display: 'inline-block' }}>{I18N.get('common_unit_yuan')}</span>
      </span>
    );
  }
}

export default FreightBillMethod;



// WEBPACK FOOTER //
// ./src/components/views/Setting/FreightBillMethod.tsx